
import { useModal } from '../contexts/ModalContext'
import CardServicos from './cardServicos'
import AccordionServicos from './accordionServicos'
import OtimizeSeuNegocio from './OtimizeSeuNegocio'
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from './carousel'
import { useState } from 'react'
import Container from './container'

export function Etapas() {
  const [hoveredIndex, setHoveredIndex] = useState(null)
  const [expandedMobileIndex, setExpandedMobileIndex] = useState(null);

  // Handle accordion toggle in mobile view - exactly like in diferenciais.jsx
  const handleAccordionToggle = (index, isOpen) => {
    if (isOpen) {
      // Close any previously opened accordion
      if (expandedMobileIndex !== null && expandedMobileIndex !== index) {
        // Find the previously opened accordion and close it
        const prevAccordion = document.querySelector(`[data-accordion-index="${expandedMobileIndex}"]`);
        if (prevAccordion) {
          prevAccordion.click();
        }
      }
      setExpandedMobileIndex(index);
    } else if (expandedMobileIndex === index) {
      setExpandedMobileIndex(null);
    }
  }

  const servicosData = [
    {
      id: 1,
      icon: '../assets/icones/ia/icone1.png',
      iconHover: '../assets/icones/ia/icone1.png',
      title: 'Diagnóstico e planejamento estratégico',
      text: 'Mapeamos as necessidades e  analisamos os desafios específicos da sua empresa. Desenvolvemos um plano personalizado que integra IA e ML para potencializar o impacto nas operações e maximizar os resultados.',
      glowColor: '#FC00218C',
      url: '',
    },
    {
      id: 2,
      icon: '../assets/icones/ia/icone2.svg',
      iconHover: '../assets/icones/ia/icone2.svg',
      title: 'Desenvolvimento de projetos inovadores',
      text: 'Nossos especialistas desenvolvem algoritmos e sistemas que se integram perfeitamente às suas plataformas, garantindo a incorporação da IA e do ML ao seu negócio sem interrupções ou complexidades desnecessárias.',
      glowColor: '#FC00218C',
      url: '',
    },
    {
      id: 3,
      icon: '../assets/icones/ia/icone3.png',
      iconHover: '../assets/icones/ia/icone3.png',
      title: 'Melhoria na gestão da  inovação',
      text: 'Implementamos soluções com foco total em segurança e compliance. Seguimos rigorosos padrões de proteção de dados para que sua empresa possa operar com confiança e tranquilidade.',
      glowColor: '#FC00218C',
      url: '',
    },
    {
      id: 4,
      icon: '../assets/icones/ia/icone4.svg',
      iconHover: '../assets/icones/ia/icone4.svg',
      title: 'Monitoramento e melhoria contínuos',
      text: 'Após a implementação, monitoramos continuamente o desempenho dos sistemas e aprimoramos as soluções para que mantenham o alto impacto e a eficiência dos resultados.',
      glowColor: '#FC00218C',
      url: '',
    },
  ]

  return (
    <div className="w-full bg-[url(../assets/banner-proposito.png)] bg-cover bg-no-repeat py-20 relative overflow-hidden text-white">
      <Container className="relative z-10">
        <h2 className="font-inter-regular text-2xl md:text-4xl text-center mb-12">
          Garantimos que cada etapa seja executada com precisão e alinhamento
          estratégico aos objetivos do seu negócio
        </h2>
        <div className="relative mx-[-1rem] md:mx-[-2rem] hidden md:block">
          <Carousel className="overflow-visible">
            <CarouselContent className="py-12 px-6 md:px-8">
              {servicosData.map((servico, index) => (
                <CarouselItem key={index} className="basis-full sm:basis-1/2 md:basis-1/3 lg:basis-1/3 pl-4 md:pl-6">
                  <div className="relative overflow-visible px-2">
                    <div 
                      className="relative h-[380px]" 
                      onMouseEnter={() => setHoveredIndex(index)}
                      onMouseLeave={() => setHoveredIndex(null)}
                    >
                      {/* OtimizeSeuNegocio component that appears on hover at the top of the card */}
                      <div 
                        className={`hidden md:block absolute left-0 right-0 top-[-90px] z-20 transition-all duration-300 ${hoveredIndex === index ? 'opacity-100 visible' : 'opacity-0 invisible'}`}
                      >
                        <OtimizeSeuNegocio 
                          text="Otimize seu negócio!"
                          buttonText="Contratar"
                          useFormularioRD={true}
                          type="gradient"
                          className="w-full"
                        />
                      </div>
                      
                      <CardServicos {...servico} height={380} className="hidden md:block" />
                    </div>
                  </div>
                </CarouselItem>
              ))}
            </CarouselContent>
            <div className="flex justify-end absolute right-16 bottom-8 z-10">
              <CarouselPrevious className="h-8 w-8 rounded-full bg-transparent hover:cursor-pointer hover:scale-130 transition-transform duration-300" />
              <CarouselNext className="h-8 w-8 rounded-full bg-transparent hover:cursor-pointer hover:scale-130 transition-transform duration-300" />
            </div>
          </Carousel>
        </div>
        <div className="md:hidden space-y-4">
          {servicosData.map((servico, index) => (
            <div key={index} className="relative">
              <AccordionServicos
                key={`mobile-${index}`}
                {...servico}
                doesThereButton={false}
                className="bg-[rgb(32,27,63)] backdrop-blur-[40px] text-left"
                onToggle={(isOpen) => handleAccordionToggle(index, isOpen)}
                accordionIndex={index}
              />
              
              {/* Mobile OtimizeSeuNegocio that appears when accordion is expanded */}
              <div 
                className={`transition-all duration-300 ease-in-out transform w-full overflow-hidden
                  ${expandedMobileIndex === index ? 'max-h-[100px] opacity-100' : 'max-h-0 opacity-0'}`}
                style={{
                  transitionProperty: 'max-height, opacity, transform',
                  transform: expandedMobileIndex === index ? 'translateY(0)' : 'translateY(-10px)',
                  zIndex: 20,
                  position: 'relative'
                }}
              >
                <OtimizeSeuNegocio 
                  text="Otimize seu negócio!"
                  buttonText="Contratar"
                  useFormularioRD={true}
                  type="gradient"
                  className="w-full mt-4"
                />
              </div>
            </div>
          ))}
        </div>
      </Container>
      <img
        src="../assets/gradiente.png"
        alt=""
        className="hidden md:block absolute bottom-0 w-full"
      />
      <img
        src="../assets/gradiente-mobile.png"
        alt=""
        className="block md:hidden absolute bottom-0 w-full"
      />
    </div>
  )
}
